import env_variables from '../../../config/env_variables'
import { apiClient } from './axiosSettings'
import getAuthHeaders from './getAuthHeaders'

export async function getConversationId(chatId: any) {
  return await apiClient.get(`${env_variables.CCP_CH_URL}/api/conversation/v1/getConvDetailsById/${chatId}`, { headers: getAuthHeaders() })
}

export async function updateContactAttributes(payload: any) {
  if(!Object.keys(payload?.attributes).length) return false
  const updated = await apiClient
    .post(`${env_variables.CCP_API_END_POINT}/api/connect/v1/updateContactAttributes`, payload, { headers: getAuthHeaders() })
    .then(() => true)
    .catch((error: any) => {
      console.log('updateContactAttributes error: ', error)
      return false
    })
  return updated
}

export async function outboundMetadata(payload: any) {
  const updated = await apiClient
    .post(`${env_variables.CCP_API_END_POINT}/api/voice/v1/outbound/metadata`, payload, { headers: getAuthHeaders() })
    .then(() => true)
    .catch((error: any) => {
      console.log('outboundCallMetadata error: ', error)
      return false
    })
  return updated
}

export async function getConversationHistory(customerID: string) {
  const result = await apiClient.get(`${env_variables.CCP_CH_URL}/api/conversation/v1/getConvHistoryByCustomer?customerId=${customerID}`, { headers: getAuthHeaders() })
  return result
}

export async function getAllowedAgent(conversationId: string, agentId: string, linkedConversationId: string) {
  const result = await apiClient.get(
    `${env_variables.CCP_API_END_POINT}/api/v1/widget/allowedagent?conversationId=${conversationId}&agentId=${agentId}&linkedConversationId=${linkedConversationId}`,
    {
      headers: getAuthHeaders()
    }
  )
  return result
}

export async function stopRecording(payload: any) {
  const updated = await apiClient
    .post(`${env_variables.CCP_API_END_POINT}/api/voice/v1/record/stop`, payload, { headers: getAuthHeaders() })
    .then(() => true)
    .catch((error: any) => {
      console.log('Disable Recording Failure: ', error)
      return false
    })
  return updated
}

export async function getReleaseNotes() {
  try {
    const result = await apiClient.get(`${env_variables.CCP_API_END_POINT}/api/v1/ces/releaseNotes?active=true`, {
      headers: getAuthHeaders()
    })
    return result
  } catch (e) {
    return {}
  }
}

export async function getReleaseNotesPDF(version) {
  try {
    const result = await apiClient.get(`${env_variables.CCP_API_END_POINT}/api/v1/ces/releaseNotes/pdf?version=${version}`, {
      headers: getAuthHeaders(),
      responseType: 'blob'
    })
    return { success: true, result }
  } catch (e) {
    return { success: false }
  }
}
export async function updateVpnDisconnectedContactId(payload) {
  try {
    const result = await apiClient.put(`${env_variables.CCP_API_END_POINT}/api/v1/ces/vpndisconnect`, payload, { headers: getAuthHeaders() })
    return { success: true, result }
  } catch (e) {
    return { success: false }
  }
}

export async function getFeatureFlags(payload: any, url?: string) {
  const { agentId = '' } = payload
  try {
    const featureFlagsResponse = await apiClient.get(`${url ?? env_variables.FG_ENDPOINT_CONVO_SUMMARY}&_agentLdp=${agentId}`, {
      headers: { 'x-api-key': 'oac-custom-panel', Authorization: localStorage.getItem('customPanelAccessToken').replaceAll('"', '') ?? '' }
    })
    return featureFlagsResponse
  } catch (error) {
    console.log('getFeatureFlags error: ', error)
    return {}
  }
}

export async function getFlagsForConversationSummary(queue: string = '') {
  try {
    const featureFlagsResponse = await apiClient.get(`${env_variables.FG_ENDPOINT_CONVO_SUMMARY}&_queue=${queue}`, {
      headers: { 'x-api-key': 'oac-custom-panel', Authorization: localStorage.getItem('customPanelAccessToken').replaceAll('"', '') ?? '' }
    })
    return featureFlagsResponse
  } catch (error) {
    console.log('getFlagForConversationSummary error: ', error)
    return {}
  }
}

export async function getFlagsForRU(queue: string = '', agentLdap = '') {
  try {
    const featureFlagsResponse = await apiClient.get(`${env_variables.FG_ENDPOINT_RU}&_queue=${queue}&_agentLdp=${agentLdap}`, {
      headers: { 'x-api-key': 'oac-custom-panel', Authorization: localStorage.getItem('customPanelAccessToken').replaceAll('"', '') ?? '' }
    })
    return featureFlagsResponse
  } catch (error) {
    console.log('getFlagForConversationSummary error: ', error)
    return {}
  }
}

export async function getFeatureFlagsForRTS(ldap: string = '') {
  try {
    // const floodgateResponse = await apiClient.get(`${env_variables.FG_ENDPOINT_RTS}&clientId=RealTimeSentiment&_agentLdp=${ldap}`, {
    //   headers: { 'x-api-key': 'oac-custom-panel', Authorization: localStorage.getItem('customPanelAccessToken').replaceAll('"', '') ?? '' }
    // })
    return {}
  } catch (err) {
    console.log('getFeatureFlagsForRTS error: ', err)
    return {}
  }
}

export async function getTranslationData(reqData: any, headers: { Authorization: string; 'x-api-key': string; }) {
  try {
    const response = await apiClient.post(`${reqData.endpoint}/api/translate/chat`, reqData.body, {headers: headers });
    return response;
  } catch(e) {
    console.log('getTranslationData error: ', e)
  }
 
}

export async function getOACFlags() {
  try {
    // const featureFlagsResponse = await apiClient.get(`${env_variables.FG_ENDPOINT_OAC_FEATURE_FLAGS}`, {
    //   headers: { 'x-api-key': 'oac-custom-panel', Authorization: localStorage.getItem('customPanelAccessToken').replaceAll('"', '') ?? '' }
    // })
    return {}
  } catch (error) {
    console.log('getOACFeatureFlags error: ', error)
    return {}
  }
}

export async function fetchBotTranscript(incidentId: any) {
  try {
    const botTranscriptApiUrl = `${env_variables.SD_DOMAIN}/api/bot/v1/transcript/`;
    // [VULN-35111] send the agent's Okta access token so the backend can
    // authenticate the user; x-api-key is retained only as a telemetry identifier.
    let oktaAccessToken = '';
    try {
      const oktaToken: any = JSON.parse(localStorage.getItem('okta-token-storage') || '');
      oktaAccessToken = oktaToken?.accessToken?.accessToken || '';
    } catch (e) {
      oktaAccessToken = '';
    }
    const response = await apiClient.get(`${botTranscriptApiUrl}?incidentId=${incidentId}`, {
      headers: {
        'x-api-key': 'yoddha-service',
        ...(oktaAccessToken ? { Authorization: `Bearer ${oktaAccessToken}` } : {}),
      },
    });
    const transcriptData = response?.data;
    return transcriptData;
  } catch (error) {
    console.error('Error fetching Bot transcript:', error);
    throw error;
  }
}